import styled from "styled-components"

export const Attribute = styled.dl`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(10ch, 1fr));\t 
  grid-gap: 1em;
  dt {
    grid-column-start: 1;
  }
  dd {
    grid-column-start: span 2;
  }
}`
